$ = require 'jquery'
_ = require 'underscore'
Backbone = require 'app/scripts/lib/backbone'
{ Storage } = require '@trello/storage'
dataUriToBlob = require 'app/scripts/lib/util/url/data-uri-to-blob'
{ getTypes } = require 'app/scripts/views/internal/data-transfer/normalize'
selectElementContents = require 'app/scripts/lib/util/selection/select-element-contents'
{ getKey, Key } = require '@trello/keybindings'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'

showClipboardAlert = (eventType) ->
  Alerts.show('card-copied-to-clipboard', 'info', 'trello-clipboard', 5000)

  me = Auth.me()
  # Only show the instructional alert if they haven't completed a copy/move via pasting.
  if me && !me.isDismissed("pasteAlert-#{eventType}Card")
    Alerts.show("paste-to-#{eventType}", 'info', 'trello-clipboard-paste', 5000)

class TrelloClipboard
  constructor: ->
    @value = ""

    $(document).on 'keydown', (e) =>
      key = getKey(e)

      # Only do this if there's something to be put on the clipboard, and it
      # looks like they're starting a copy shortcut
      if !@value || !(e.ctrlKey || e.metaKey)
        return

      if $(e.target).is('#clipboard')
        if key == Key.c
          # If a new copy happens, they haven't cut anymore
          @clearCut()

          showClipboardAlert('copy')
        return

      if $(e.target).is('input:visible,textarea:visible')
        return

      # Abort if it looks like they've selected some text (maybe they're trying
      # to copy out a bit of the description or something)
      if window.getSelection?()?.toString()
        return

      if document.selection?.createRange().text
        return

      _.defer =>
        $clipboardContainer = $('#clipboard-container')
        $clipboardContainer.empty().show()
        $('<div id="clipboard" contenteditable="true"></div>')
        .text(@value)
        .appendTo($clipboardContainer)
        .focus()
        .select()
        selectElementContents(document.getElementById('clipboard'))

    $(document).on 'keyup', (e) =>
      if @isClipboard(e.target)
        newValue = $('#clipboard').text()
        if newValue == ''
          # They must have used the cut shortcut
          @setCut(@value)
          showClipboardAlert('move')

      @checkForPastedImage()

    $(document).on 'paste', (e) =>
      if !_.isEmpty(getTypes(e.originalEvent.clipboardData))
        @cancelPasteImage()
      # If they pasted something, they aren't cutting anymore ... but let
      # all the other paste handlers run first, so they can check isCut()
      @clearCutTimeout = setTimeout @clearCut.bind(@), 1000

  set: (@value) ->
    $clipboard = $('#clipboard')
    if $clipboard.length
      $clipboard.text(@value)
      .focus()
      .select()
      selectElementContents(document.getElementById('clipboard'))

  setCut: (value) ->
    try
      if @clearCutTimeout?
        clearTimeout(@clearCutTimeout)
        @clearCutTimeout = null
      Storage.set 'cut', value
    return

  getCut: ->
    try
      return Storage.get 'cut'
    null

  clearCut: ->
    try
      Storage.unset 'cut'
      @clearCutTimeout = null
    return

  isCut: (value) ->
    value == @getCut()

  isClipboard: (element) ->
    element.id == 'clipboard'

  clear: ->
    $('#clipboard-container').empty().hide()

  checkForPastedImage: ->
    clearTimeout(@pasteImageTimeout)

    # We have to yield so the image actually shows up in the clipboard
    @pasteImageTimeout = setTimeout =>
      $pastedImage = $('#clipboard-container').find('img')
      @clear()
      if $pastedImage.length > 0
        src = $pastedImage.attr('src')
        # Firefox helpfully uses data: URIs that we can work with, unlike
        # Safari which is currently using useless the "fake-webkit-url"
        # protocol
        if /^data:/.test(src)
          @trigger('pasteImage', dataUriToBlob(src))
          return
    , 1

  cancelPasteImage: ->
    clearTimeout @pasteImageTimeout
    @clear()

_.extend TrelloClipboard.prototype, Backbone.Events

module.exports = new TrelloClipboard()
